import c0 from './add_button_controller';
import c1 from './add_to_queue_controller';
import c2 from './blocks/episodes/media_progress_controller';
import c3 from './blocks/layout/tab_bar_component_controller';
import c4 from './blocks/live_streams/banner_component_controller';
import c5 from './blocks/live_streams/chat_tip_controller';
import c6 from './blocks/live_streams/editorial_info_panel_component_controller';
import c7 from './blocks/live_streams/pinned_tips_controller';
import c8 from './blocks/newsletters/resend_feedback_controller';
import c9 from './bridge/notification_controller';
import c10 from './button_controller';
import c11 from './chat_panel_controller';
import c12 from './connect_link_controller';
import c13 from './live_poll_controller';
import c14 from './notification_controller';
import c15 from './poll_interaction_controller';
import c16 from './queue_button_controller';
import c17 from './referral_source_controller';
import c18 from './shareable_link_controller';
import c19 from './thumbnail_controller';
import c20 from './vote_controller';
export const definitions = [
	{identifier: 'add-button', controllerConstructor: c0},
	{identifier: 'add-to-queue', controllerConstructor: c1},
	{identifier: 'blocks--episodes--media-progress', controllerConstructor: c2},
	{identifier: 'blocks--layout--tab-bar-component', controllerConstructor: c3},
	{identifier: 'blocks--live-streams--banner-component', controllerConstructor: c4},
	{identifier: 'blocks--live-streams--chat-tip', controllerConstructor: c5},
	{identifier: 'blocks--live-streams--editorial-info-panel-component', controllerConstructor: c6},
	{identifier: 'blocks--live-streams--pinned-tips', controllerConstructor: c7},
	{identifier: 'blocks--newsletters--resend-feedback', controllerConstructor: c8},
	{identifier: 'bridge--notification', controllerConstructor: c9},
	{identifier: 'button', controllerConstructor: c10},
	{identifier: 'chat-panel', controllerConstructor: c11},
	{identifier: 'connect-link', controllerConstructor: c12},
	{identifier: 'live-poll', controllerConstructor: c13},
	{identifier: 'notification', controllerConstructor: c14},
	{identifier: 'poll-interaction', controllerConstructor: c15},
	{identifier: 'queue-button', controllerConstructor: c16},
	{identifier: 'referral-source', controllerConstructor: c17},
	{identifier: 'shareable-link', controllerConstructor: c18},
	{identifier: 'thumbnail', controllerConstructor: c19},
	{identifier: 'vote', controllerConstructor: c20},
];
